import React from 'react'
import StagesManager from '../components/StagesManager';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import Responsive from '../components/Responsive';
import RoomsHome from './Rooms/RoomsHome';
import Room from './Rooms/Room';
import { nanoid } from 'nanoid';
import HttpServices from '../utils/Http.services';
import RoomsToolbar from './Rooms/RoomsToolbar';

class Rooms extends React.Component {
    state = {
        isLoading: false,
        path: ''
    }


    componentDidMount() {
        this.init()

    }


    componentDidUpdate(prevProps) {
        if (JSON.parse(JSON.stringify(this.props.windowData.path)) != JSON.parse(JSON.stringify(prevProps.windowData.path?.length))) {
            this.init()
        }
    }


    init = () => {
        // console.log('data', this.props.data)

        // let data = this.props.data
        // console.log('thiss.props.windowsdata', this.props.windowData.path, this.props.baseUrl)

        // console.log(this.props.windowData.path, this.props.baseUrl)
        let secondInLink = this.props.windowData.path[this.props.baseUrl.length]
        let thirdInLink = this.props.windowData.path[this.props.baseUrl.length + 1]
        // console.log(secondInLink, thirdInLink)
        if (secondInLink == 'room' && thirdInLink) {

            this.stageManager.changeStage('room', null, null, true)

        } else {
            this.stageManager.changeStage('home', null, null, true)
        }
    }





    setData = (data, cb) => {
        let newData = this.state.data
        for (const [key, value] of Object.entries(data)) {
            newData[key] = value
        }
        this.setState({ data: newData }, () => {
            if (cb) { cb() }
        })
    }



    createRoom = (cb, later, frame) => {

        // console.log("createRoom")
        if (this.props.page?._id || frame) {
            this.setState({ isLoading: true }, () => {
                // console.log('beeeeeeeeeeef', this.props)
                // console.log('thisCh', this.props.windowData?.path, this.props.baseUrl)
                let myFrame = frame ?? this.props.page?._id
                let body = { frame: myFrame }

                // console.log(body)

                HttpServices.request('createRoom', body, (fetchResolve, fetchError) => {
                    // console.log('afffffffffffffter', fetchResolve, fetchError)
                    this.setState({ isLoading: false })
                    cb(fetchResolve.info.roomId)
                    if (fetchError) {
                        // console.log(fetchError);
                        return
                    }
                    // console.log('fetchResolve.info.roomId', fetchResolve.info.roomId)
                    if (!later) {
                        // this.props.changeWindow('rooms', { type: 'rooms', path: ['rooms', fetchResolve.info.roomId] })
                        this.changePage(["room", fetchResolve.info.roomId])

                    }
                })
            })
        }

    }
    joinRoomByLink = (room) => {
        // console.log(room)
        let scope = this.props.scope
        // let frame = this.props.page?._id ?? scope
        let id = room.split('/')
        id = id[id.length - 1]

        let finalList = ['room', id]
        // if (this.props.page) {
        //     finalList = [this.props.page?._id, ...finalList]
        // }

        // console.log(finalList)

        this.changePage(finalList)
        // this.props.changeWindow('rooms', { type: 'rooms', path: ['rooms', room] })
    }



    changePage = (list, info) => {
        // console.log(list)
        let finalList = list ?? []
        if (this.props.page) {
            finalList = [this.props.page?._id, ...finalList]
        }
        this.props.changePage(finalList, info)

    }




    render() {
        return (
            <div className="w-100  d-flex Rooms h-100 window-content-radius "  >
                {/* <div className=' w-100 h-100'> */}
                <StagesManager className={'flex-1 d-flex'} ref={el => this.stageManager = el} fast={true}  >
                    <RoomsHome stage={1} stageName={'home'} functionsHandler={this.props.functionsHandler} windowData={this.props.windowData} page={this.props.page} applet={this.props.applet} baseUrl={[...this.props.baseUrl]} initData={this.state.data} language={this.props.settings.language} setData={this.setData} width={this.props.width} changePage={this.props.changePage} isLoading={this.state.isLoading} createRoom={this.createRoom} joinRoomByLink={this.joinRoomByLink} setHeader={this.props.setHeader} toolbarView={this.props.toolbarView} scope={this.props.scope} />
                    <Room stage={1} stageName={'room'} page={this.props.page} functionsHandler={this.props.functionsHandler} windowData={this.props.windowData} baseUrl={this.props.baseUrl} initData={this.state.data} language={this.props.settings.language} setData={this.setData} width={this.props.width} changePage={this.changePage} height={this.props.height} data={this.props.data} changeWindow={this.props.changeWindow} setHeader={this.props.setHeader} toolbarView={this.props.toolbarView} scope={this.props.scope} />
                </StagesManager>
                {/* </div> */}
            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Rooms);
